// @core/api/endpoints/affiliate/get_payout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PayoutResponse,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Get payout by ID
 * Retrieves payout by the specified identifier.
 */
export async function GetPayout(
  payout_id: string,
  options?: RequestOptions
): Promise<PayoutResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payouts/:payout_id`;
  requestPath = requestPath.replace(':payout_id', encodeURIComponent(payout_id));
  const requestOptions = options;
  return client.get<PayoutResponse>(requestPath, { ...requestOptions });
}
